import useAPI from './useAPI';

const useLoginUserData = () => {
  const { data } = useAPI({
    url: '/auth/get/info',
    method: 'GET',
  });

  return { data: data?.result?.data };
};

export default useLoginUserData;
